<template>
  <div>
    <p>{{ notificationData.subject}}</p>
    <p v-html="notificationData.message"></p>
  </div>
</template>

<script>
export default {
  name: 'schoolNotification',
  props: {
    notificationData: {
      type: Object,
      required: true
    }
  }
}
</script>
